import React from 'react';
import { TextField } from '@one-thd/sui-atomic-components';
import { Controller, useFormContext } from 'react-hook-form';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { TAddressFormValues } from '../../../../../models/common/address';
import { getTextFieldStatus } from '../../../../../utils/forms';
import { getHyphenatedPhoneNumber } from '../../../../../utils/general';
import { PHONE_PLACEHOLDER } from '../../../../../constants/placeholders';
import { ZipCodeCitySelectFields } from '../../../../shared/zipcode/zipcode';
import { ADDRESS_FORM_DATA_TEST_IDS } from '../../../../../constants/address-constants';

export const AddressFormFields = () => {
  const formMethods = useFormContext<TAddressFormValues>();

  const {
    control,
    formState: { errors: formErrors },
  } = formMethods;

  return (
    <div className="sui-grid sui-gap-y-6 sui-mb-10">
      <Controller
        name="firstName"
        control={control}
        render={({ field }) => {
          const { ref, value, name, onChange, ...rest } = field;
          return (
            <TextField
              label="First Name"
              data-testid={ADDRESS_FORM_DATA_TEST_IDS.FIRST_NAME}
              required
              status={getTextFieldStatus(formErrors.firstName)}
              statusMessage={formErrors.firstName?.message}
              value={value || ''}
              name={name}
              onChange={onChange}
              InputProps={{
                inputProps: { ...rest, 'data-qm-mask': '' },
              }}
            />
          );
        }}
      />
      <Controller
        name="lastName"
        control={control}
        render={({ field }) => {
          const { ref, value, name, onChange, ...rest } = field;
          return (
            <TextField
              label="Last Name"
              data-testid={ADDRESS_FORM_DATA_TEST_IDS.LAST_NAME}
              required
              status={getTextFieldStatus(formErrors.lastName)}
              statusMessage={formErrors.lastName?.message}
              value={value || ''}
              name={name}
              onChange={onChange}
              InputProps={{
                inputProps: { ...rest, 'data-qm-mask': '' },
              }}
            />
          );
        }}
      />
      <Controller
        name="addressLine1"
        control={control}
        render={({ field }) => {
          const { ref, value, name, onChange, ...rest } = field;
          return (
            <TextField
              label="Address"
              data-testid={ADDRESS_FORM_DATA_TEST_IDS.ADDRESS_LINE_1}
              required
              status={getTextFieldStatus(formErrors.addressLine1)}
              statusMessage={formErrors.addressLine1?.message}
              value={value || ''}
              name={name}
              onChange={onChange}
              InputProps={{
                inputProps: { ...rest, 'data-qm-mask': '' },
              }}
            />
          );
        }}
      />
      <Controller
        name="addressLine2"
        control={control}
        render={({ field }) => {
          const { ref, value, name, onChange, ...rest } = field;
          return (
            <TextField
              label="Address Line 2"
              data-testid={ADDRESS_FORM_DATA_TEST_IDS.ADDRESS_LINE_2}
              status={getTextFieldStatus(formErrors.addressLine2)}
              statusMessage={formErrors.addressLine2?.message}
              optional
              value={value || ''}
              name={name}
              onChange={onChange}
              InputProps={{
                inputProps: { ...rest, 'data-qm-mask': '' },
              }}
            />
          );
        }}
      />
      <QueryProvider cacheKey="zipCode">
        <ZipCodeCitySelectFields />
      </QueryProvider>
      <Controller
        name="primaryPhone"
        control={control}
        render={({ field }) => {
          const { ref, value, name, onChange, ...rest } = field;
          return (
            <TextField
              label="Phone"
              data-testid={ADDRESS_FORM_DATA_TEST_IDS.PRIMARY_PHONE}
              required
              status={getTextFieldStatus(formErrors.primaryPhone)}
              statusMessage={formErrors.primaryPhone?.message}
              placeholder={PHONE_PLACEHOLDER}
              value={value || ''}
              name={name}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                onChange(
                  getHyphenatedPhoneNumber(event.currentTarget.value || ''),
                );
              }}
              InputProps={{
                inputProps: {
                  ...rest,
                  'data-qm-mask': '',
                },
              }}
            />
          );
        }}
      />
    </div>
  );
};
